<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import { us_states } from '@/state/helpers';
import Swal from 'sweetalert2';
import { required } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			states: [],
			userData: JSON.parse(localStorage.getItem('web_user')),
			typeSubmit: false,
			addBackgroundCheckForm: {
				ssn: null,
				ssn_remove: null,
				driver_license_number: null,
				driver_license_number_remove: null,
				user_type_id: null,
				driver_license_state: null,
				previous_residence: [
					{
						previous_state: null,
						previous_city: null,
					},
				],
			},
		};
	},
	validations: {
		addBackgroundCheckForm: {
			ssn: { required },
			driver_license_number: { required },
			driver_license_state: { required },
		},
	},
	mounted() {
		this.getBackgroundDetails();
		this.setStatesProps();
	},
	methods: {
		contactt() {
			router.push({ name: 'contact' });
		},

		// set states
		setStatesProps() {
			us_states.forEach((state) => {
				this.states.push({ value: state, text: state });
			});
		},
		skipToReview() {
			router.push({ name: 'review-application' });
		},
		contact() {
			router.push({ name: 'contact-info' });
		},
		questions() {
			router.push({ name: 'questions' });
		},
		addBackgroundDetails() {
			this.typeSubmit = true;
			// stop here if form is invalid
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const userData = JSON.parse(localStorage.getItem('web_user'));
				var config = {
					headers: { Authorization: 'Bearer ' + userData.token },
				};
				if (userData.token) {
					this.addBackgroundCheckForm.user_type_id = userData['user_type_id'];
					axios
						.post('user/backgroundDetails', this.addBackgroundCheckForm, config)
						.then((res) => {
							if (res.status == 200) {
								router.push({ name: 'mentor-references' });
							}
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err.response.data?.error?.message || err.response.data?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		// Getting Current User Background Details
		getBackgroundDetails() {
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			if (userData.token) {
				axios
					.get('user/backgroundDetails/' + userData['id'] + '?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						if (res.status == 200) {
							this.addBackgroundCheckForm = res.data.response;
							this.addBackgroundCheckForm.ssn_remove = false;
							this.addBackgroundCheckForm.driver_license_number_remove = false;
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 404) {
								console.log('No Record Found');
							}
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		/**
		 * Add the Residence in form
		 */
		AddResidence() {
			this.addBackgroundCheckForm.previous_residence.push({
				previous_state: '',
				previous_city: '',
			});
		},
		/**
		 * Delete the residence row from form
		 */
		deleteResidence(index) {
			this.addBackgroundCheckForm.previous_residence.splice(index, 1);
		},

		goToProfile() {
			router.push({ name: 'profile' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<!-- <h3 class="title" v-if="userData.is_mentor"> Mentor / Volunteer Details</h3> -->
						<h3 class="title">Become a Mentor</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a @click="contactt" href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>
		<div id="create-account">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12">
						<!-- <div class="progress-container" v-if="userData['user_type_id'] === 4">
              <div class="progress-box">
                1
              </div>
              <div class="progress-box">
                2
              </div>
              <div class="progress-box">
                3
              </div>
              <div class="progress-box active">
                4
              </div>
              <div class="progress-box">
                5
              </div>
            </div>

            <div class="progress-container" v-else>
                <div class="progress-box">1</div>
                <div class="progress-box active">2</div>
                <div class="progress-box">3</div>
                <div class="progress-box">4</div>
                <div class="progress-box">5</div>
                <div class="progress-box">6</div>
            </div> -->

						<div class="progress-container">
							<div class="progress-box active">1</div>
							<div class="progress-box">2</div>
						</div>
					</div>
				</div>
				<form class="custom-form" @submit.prevent="addBackgroundDetails">
					<div class="row">
						<div class="col-12 mb-5">
							<h3 class="main-title">Background Check Information</h3>
						</div>

						<div class="col-12 mb-5">
							<h3 class="font-size-20 text-start">Authorization to Release Information</h3>
							<span class="font-size-16 d-inline-block mb-2"
								>I understand that in processing my application with Mn Adult & Teen Challenge, an investigation may be made in which information is obtained through personal interviews, written requests, and a review of information held by acquaintances, law enforcement and/or other government
								agencies. I further understand and waive my right of privacy in this investigation and release and hold harmless Mn Adult & Teen Challenge and its agents from liability.</span
							>
							<span class="font-size-16 d-inline-block mb-2"
								>I understand that several reports may be requested and may include information as to my character, and/or work habits. Further, I understand that you may be requesting information concerning my motor vehicle operations history and criminal history from various private and public
								sources along with other public records that are available.</span
							>
							<span class="font-size-16 d-inline-block mb-2"
								>I hereby authorize and release from all liability, without reservation, Mn Adult & Teen Challenge, other agents of Mn Adult & Teen Challenge, and any law enforcement agency, administrator, state/federal agency, institution, information service bureau, insurance company or person
								gathering or furnishing the above information.</span
							>
						</div>
					</div>
					<div class="row mb-5">
						<div class="col-12 col-md-4 mb-3">
							<label>SSN</label>
							<input
								v-mask="'###-##-####'"
								v-model="addBackgroundCheckForm.ssn"
								type="text"
								placeholder="Enter SSN *"
								class="form-control"
								name="ssn"
								:class="{
									'is-invalid': typeSubmit && $v.addBackgroundCheckForm.ssn.$error,
								}"
							/>
							<span class="text-muted ps-3 d-inline-block mt-2 font-size-14">SSNs are encrypted for security, submitted for a background check, and then removed. We do not store them in our database.</span>
							<div v-if="typeSubmit && $v.addBackgroundCheckForm.ssn.$error" class="invalid-feedback">
								<span v-if="!$v.addBackgroundCheckForm.ssn.required">SSN is required.</span>
								<span v-if="!$v.addBackgroundCheckForm.ssn.numeric">Enter only Numbers.</span>
							</div>
						</div>

						<div class="col-12 col-md-4 mb-3">
							<label>Driver’s License Number</label>
							<input
								v-model="addBackgroundCheckForm.driver_license_number"
								type="text"
								placeholder="Enter Driver’s License Number *"
								class="form-control"
								name="driver_license_number"
								:class="{
									'is-invalid': typeSubmit && $v.addBackgroundCheckForm.driver_license_number.$error,
								}"
							/>
							<span class="text-muted ps-3 d-inline-block mt-2 font-size-14"
								>{{ userData['user_type_id'] === 3 ? 'Mentors' : 'Volunteers' }} must have a valid driver’s license. <br />
								Minnesota driver’s license numbers begin with a letter followed by 12 numbers
							</span>
							<div v-if="typeSubmit && $v.addBackgroundCheckForm.driver_license_number.$error" class="invalid-feedback">
								<span v-if="!$v.addBackgroundCheckForm.driver_license_number.required">Driver License Number is required.</span>
								<!-- <span v-if="!$v.addBackgroundCheckForm.driver_license_number.numeric">Enter only Numbers.</span> -->
							</div>
						</div>

						<div class="col-12 col-md-4 mb-3">
							<label>Driver’s License State</label>
							<b-form-select
								class="form-select form-control"
								v-model="addBackgroundCheckForm.driver_license_state"
								:options="states"
								:class="{
									'is-invalid': typeSubmit && $v.addBackgroundCheckForm.driver_license_state.$error,
								}"
							>
								<option slot="first" :value="null" selected>Select Driver’s License State *</option>
							</b-form-select>
							<span class="text-muted ps-3 d-inline-block mt-2 font-size-14">Select Driver’s License State</span>
							<!-- <input v-model="addBackgroundCheckForm.driver_license_state" type="text" placeholder="Enter Driver’s License Number" class="form-control" name="driver_license_number"
                     :class="{'is-invalid': typeSubmit && $v.addBackgroundCheckForm.driver_license_state.$error }"/> -->
							<div v-if="typeSubmit && $v.addBackgroundCheckForm.driver_license_state.$error" class="invalid-feedback">
								<span v-if="!$v.addBackgroundCheckForm.driver_license_state.required">Driver's License State is required.</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 inner-repeater mb-4">
							<h2 class="font-size-14 fw-bold mt-3 mb-2">Previous Residence(s)</h2>
							<div class="inner mb-3 row">
								<label>
									<!-- Please provide information for the locations you have lived in the past 5 years -->
									If the address you previously entered in your application is not the only place you have lived in the past 5 years, please list the other cities and states in which you have lived:
								</label>
								<div v-for="(data, index) in addBackgroundCheckForm.previous_residence" :key="index" class="inner mb-3 row">
									<div class="col-5">
										<!-- <input v-model="data.previous_state" type="text" name="previous_state" class="inner form-control" placeholder="Enter Previous Address State"/> -->
										<b-form-select class="form-select form-control" v-model="data.previous_state" :options="states">
											<option slot="first" :value="null" selected>Select State</option>
										</b-form-select>
										<small class="d-inline-block ms-4 mt-2 font-size-14">Select State</small>
									</div>
									<div class="col-6">
										<input v-model="data.previous_city" type="text" name="previous_city" class="inner form-control" placeholder="Enter City" />
									</div>
									<div class="col-1">
										<div class="d-grid">
											<button type="button" @click="deleteResidence(index)" class="btn">
												<i class="text-danger bx bxs-trash"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<button type="button" title="Add Residence" @click="AddResidence" class="d-flex py-0 px-0 btn"><i class="font-size-18 me-1 bx bxs-plus-circle"></i> Add Residence</button>
						</div>
					</div>
					<div class="row">
						<div class="mb-5 col-4 text-md-start">
							<!-- <b-button type="button" @click="skipToReview" variant="custom">
                  <i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
                  Skip To Review
                </b-button> -->
						</div>

						<div class="mb-5 col-8 text-center text-md-end">
							<b-button type="button" @click="goToProfile" variant="custom">
								<i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i>
								<span>Back to Profile</span>
							</b-button>
							<b-button type="submit" variant="custom">
								<span>Character Reference</span>
								<i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i>
							</b-button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
